import React from 'react';
import FieldView from "../../../../components/FieldView";
import {formDefFazendaLeite} from "../forms";
import {QuestionarioFazendaObject} from "../../../../models/Questionario";
import QuestionarioLeiteV2 from "./QuestionarioLeiteV2";


interface QuestionarioLeiteV3Props {
  questionario: QuestionarioFazendaObject
}

const QuestionarioLeiteV3: React.FC<QuestionarioLeiteV3Props> = ({questionario}) => {
  return (
    <>
      <QuestionarioLeiteV2 questionario={questionario}/>
      <FieldView value={questionario.producao_litros_dia}
                 def={formDefFazendaLeite.producao_litros_dia}/>
    </>
  );
}

export default QuestionarioLeiteV3;
